import { render } from "./AssurancePage.vue?vue&type=template&id=1125fe24"
import script from "./AssurancePage.vue?vue&type=script&lang=js"
export * from "./AssurancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__